import classNames from 'classnames';
import './style.scss'

export const OverLay = ({ children, text, className, textClassName }) => {

    return <div className={classNames("relative max-w-screen-lg select-none", className)}>
        <div className={classNames("overlay-text font-bold text-purple-600", textClassName)}>{text}</div>
        <div className="pointer-events-none overlay-container">{children}</div>
    </div>;
}
